// extracted by mini-css-extract-plugin
export default {"contactCtn":"Contact_contactCtn__4nXLD","formCtn":"Contact_formCtn__4WUhb","success":"Contact_success__JKQdt"};